const formatThousand = (number?: number):

string => number?.toLocaleString() ?? "0";

export default formatThousand;
